import apiService from 'services/apiService';

const monitorApiUrl = `${window._env_.MONITOR_API_DOMAIN}`;
const platformApiUrl = `${window._env_.PLATFORM_API_DOMAIN}`;

const patchBulkArchiveClients = (entityIds) => {
  const url = `${monitorApiUrl}/v1/entities/archive/bulk`;
  return apiService.patch(url, { entityIds: entityIds.map((entityId) => entityId.toString()) });
};

const postBulkSyncClients = (entityIds) => {
  const url = `${monitorApiUrl}/v1/entities/snapshots/bulk`;
  return apiService.post(url, { entityIds: entityIds.map((entityId) => entityId.toString()) });
};

const postBulkUpdateTagsClients = (entityList) => {
  const url = `${monitorApiUrl}/v1/entities/tags/assignments/bulk`;
  return apiService.post(url, { entityList });
};

const patchBulkAddManagerClients = (body) => {
  const { entityIds } = body;

  const stringifiedEntityIds = entityIds.map((entityId) => entityId.toString());

  const url = `${platformApiUrl}/v1/entities/manager/bulk`;
  return apiService.patch(url, { ...body, entityIds: stringifiedEntityIds });
};

export {
  patchBulkArchiveClients,
  postBulkSyncClients,
  postBulkUpdateTagsClients,
  patchBulkAddManagerClients,
};
